/*
 * Seletor de kit da pagina de produto.
 *
 * Escolher um nivel escreve a quantidade no input do Dawn e dispara o evento
 * change, que e o que o formulario de compra escuta. Nao existe estado paralelo
 * aqui: quem manda continua sendo o campo de quantidade, entao mexer nele na
 * mao tambem funciona e o carrinho recebe sempre o mesmo valor.
 */
if (!customElements.get('kit-br')) {
  customElements.define(
    'kit-br',
    class KitBr extends HTMLElement {
      connectedCallback() {
        this.opcoes = Array.from(this.querySelectorAll('[data-quantidade]'));
        if (!this.opcoes.length) return;

        this.opcoes.forEach((opcao) => {
          opcao.addEventListener('click', () => this.selecionar(opcao));
        });

        this.addEventListener('keydown', (evento) => this.navegar(evento));

        // Se alguem mexer no campo de quantidade direto, o destaque acompanha.
        this.entrada?.addEventListener('change', () => this.sincronizar());
        this.sincronizar();
      }

      get entrada() {
        return document.getElementById(`Quantity-${this.dataset.section}`);
      }

      selecionar(opcao) {
        const quantidade = opcao.dataset.quantidade;
        const entrada = this.entrada;
        if (!entrada) return;

        entrada.value = quantidade;
        entrada.dispatchEvent(new Event('change', { bubbles: true }));
        this.marcar(opcao);
      }

      marcar(selecionada) {
        this.opcoes.forEach((opcao) => {
          opcao.setAttribute('aria-checked', opcao === selecionada ? 'true' : 'false');
        });
      }

      // Reflete no seletor a quantidade que estiver no campo, se ela for um nivel.
      sincronizar() {
        const atual = this.entrada?.value;
        const correspondente = this.opcoes.find((o) => o.dataset.quantidade === atual);
        if (correspondente) this.marcar(correspondente);
      }

      // Setas navegam entre os niveis, como manda o padrao de radiogroup.
      navegar(evento) {
        const teclas = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
        if (!teclas.includes(evento.key)) return;

        const atual = this.opcoes.indexOf(document.activeElement);
        if (atual === -1) return;

        evento.preventDefault();
        const avanca = evento.key === 'ArrowRight' || evento.key === 'ArrowDown';
        const proximo = (atual + (avanca ? 1 : -1) + this.opcoes.length) % this.opcoes.length;

        this.opcoes[proximo].focus();
        this.selecionar(this.opcoes[proximo]);
      }
    }
  );
}
